import React, { useContext, useRef, useState } from "react";
import axios from "axios";

import { StepperContext } from "../../Contexts/Stepper";
import { LanguageContext } from "../../Contexts/Language";
import { UserPhoneContext } from "../../Contexts/UserPhone";
import { PHONE_NUMBER_REGEX } from "../../utils/constants";
import messages from "../../utils/messages";

export const Step2 = () => {
  const inputEl = useRef();

  const { lang } = useContext(LanguageContext);
  const { setUserPhone } = useContext(UserPhoneContext);
  const { enterPhoneNumber, phoneRequired, phoneInvalid, confirm } =
    messages[lang];

  const [blur, setBlur] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [validPhone, setValidPhone] = useState(true);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [serverErr, setServerErr] = useState("");

  const { step, setStep } = useContext(StepperContext);

  const handleSubmit = async (e) => {
    try {
      // validations
      e.preventDefault();
      if (!validatePhoneNumber(phone)) {
        setValidPhone(false);
        return;
      }
      setLoading(true);
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/users/request_delete_account`,
        {
          phone_number: phone,
        },
        {
          headers: {
            "Accept-Language": lang,
          },
        }
      );
      setUserPhone(phone);
      setLoading(false);
      setStep(step + 1);
    } catch (error) {
      setLoading(false);
      setServerErr(error?.response?.data?.message);
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    return PHONE_NUMBER_REGEX.test(phoneNumber);
  };

  const handlePhoneChange = (e) => {
    setServerErr("");
    setPhone(e.target.value);
    setIsBtnDisabled(!validatePhoneNumber(e.target.value));
    setValidPhone(validatePhoneNumber(e.target.value));
  };

  return (
    <div>
      <p>{enterPhoneNumber}</p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="textfield">
              <div
                className={`textfield_input ${
                  blur && "textfield_input_focused"
                }`}
                onClick={() => {
                  inputEl.current.focus();
                }}>
                <div className="textfield_input_adornment">
                  <span className="textfield_input_adornment_text">+20 </span>
                </div>
                <input
                  ref={inputEl}
                  type="text"
                  id="phone"
                  placeholder="1xxxxxxxxx"
                  value={phone}
                  onChange={handlePhoneChange}
                  style={{
                    fontSize: "16px",
                    verticalAlign: "centre",
                    direction: "ltr",
                  }}
                  required
                  className="textfield_input_field"
                  onFocus={() => setBlur(!blur)}
                  onBlur={() => setBlur(false)}
                />
              </div>
            </div>
            <p
              className="error"
              style={{
                visibility: !validPhone || !!serverErr ? "visible" : "hidden",
              }}>
              {serverErr
                ? serverErr
                : phone === ""
                ? phoneRequired
                : phoneInvalid}
            </p>
            <button
              className={isBtnDisabled || !!serverErr ? "disabled" : ""}
              type="submit"
              disabled={isBtnDisabled || !!serverErr}>
              {confirm}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
